import { z } from "zod";
import { catalogStatusSchema } from "./catalog-products.js";
import { defineEndpoint } from "./endpoint.js";
/** Product search with Meilisearch (docs/specs/search.md, C-08). */
export const SEARCH_INDEX = "variants";
/** One document per variant in the `variants` index; the Admin types its search hits with it. */
export const variantSearchDocumentSchema = z.object({
    id: z.uuid(),
    tenant_id: z.uuid(),
    product_id: z.uuid(),
    product_name: z.string(),
    variant_label: z.string(),
    sku: z.string(),
    barcodes: z.array(z.string()),
    category_id: z.uuid().nullable(),
    category_names: z.array(z.string()),
    brand_id: z.uuid().nullable(),
    brand_name: z.string().nullable(),
    /** DG-08 (BK-01): the book's authors, translators and editors (a shop searches books by author). */
    author_names: z.array(z.string()).default([]),
    tag_names: z.array(z.string()),
    price_paisa: z.int(),
    status: catalogStatusSchema,
    image_file_id: z.uuid().nullable(),
    /** Published in the online store (B-74); the storefront searches only these. */
    storefront: z.boolean().default(false),
    indexed_at: z.int(),
});
/** `GET /v1/search/token`: a tenant token for searching Meilisearch directly (filtered to the caller's tenant). */
export const searchTokenSchema = z.object({
    /** Meilisearch base URL as the browser reaches it. */
    host: z.url(),
    indexUid: z.string(),
    token: z.string(),
    expiresAt: z.iso.datetime(),
});
export const searchReindexResultSchema = z.object({ queued: z.literal(true) });
export const getSearchToken = defineEndpoint({
    tag: "catalog",
    name: "getSearchToken",
    method: "GET",
    path: "/v1/search/token",
    access: { permission: "catalog.view" },
    summary: "A short-lived token to search this business's products in Meilisearch",
    status: 200,
    response: searchTokenSchema,
    errors: ["SEARCH_UNAVAILABLE"],
});
export const reindexSearch = defineEndpoint({
    tag: "catalog",
    name: "reindexSearch",
    method: "POST",
    path: "/v1/search/reindex",
    access: { permission: "catalog.manage" },
    summary: "Rebuild this business's search index (runs as a job)",
    status: 202,
    response: searchReindexResultSchema,
});
//# sourceMappingURL=search.js.map